<template>
  <v-flex class="billPayments" data-qa="paymentsreviewscreen-flex-zyh24">
   <v-layout wrap class="ml-2 billPayments--gradientBGposition" data-qa="paymentsreviewscreen-layout-l9l7so">
     <v-flex
       xs12
       sm12
       md12
       lg12
       xl12
       :style="{ background: dashboardGradient, height: '180px' }"
      data-qa="paymentsreviewscreen-flex-11qy9">
       <v-container class="billPayments--title-padding" data-qa="paymentsreviewscreen-container-xzqb0l">
         <v-flex xs12 sm12 md12 lg12 xl12 data-qa="paymentsreviewscreen-flex-dxqdpl">
           <v-row no-gutters data-qa="paymentsreviewscreen-row-2z5anl">
             <v-layout row wrap class="pb-2 pl-12" data-qa="paymentsreviewscreen-layout-x8nftj">
               <!-- <v-flex xs2 sm2 md2 lg1 xl1 class="pt-6 pl-12" data-qa="paymentsreviewscreen-flex-0timpq"> -->
                 <!-- <v-row justify="start" class="pl-2" data-qa="paymentsreviewscreen-row-53mogp"> -->
                   <div class="pt-3" data-qa="paymentsreviewscreen-div-t7xg8k">
                   <v-avatar :tile="false" size="35" color="white" data-qa="paymentsreviewscreen-avatar-90snzv">
                     <v-icon :color="primaryColor" data-qa="paymentsreviewscreen-icon-p68xhb">mdi-receipt</v-icon>
                   </v-avatar>
                   </div>
                 <!-- </v-row> -->
               <!-- </v-flex> -->
               <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="paymentsreviewscreen-flex-hb6oxn">
                 <v-row no-gutters data-qa="paymentsreviewscreen-row-udala">
                   <font class="text-h5 font-weight-light white--text">
                     {{ $t("billPayments.title")}}</font
                   >
                 </v-row>
               </v-flex>
             </v-layout>
           </v-row>
         </v-flex>
       </v-container>
       <!-- <v-flex
             v-if="!repeatPayment && !repeatBillPayment"
             sm12
             xs12
             md12
             lg12
             xl12
             class="hidden-md-and-down pb-2"
             style="
                   padding-right: 70px;
                   padding-top: 15px !important;
                   text-align: right !important;
                   float: right;
                   "
            data-qa="paymentsreviewscreen-flex-lhb2rb">
       </v-flex> -->
       <!-- <v-flex
             v-if="repeatPayment || repeatBillPayment"
             sm12
             xs12
             md12
             lg12
             xl12
             class="hidden-md-and-down pb-2"
             style="
                   padding-right: 70px;
                   padding-top: 15px !important;
                   text-align: right !important;
                   float: right;
                   "
            data-qa="paymentsreviewscreen-flex-lhd06">
       </v-flex> -->
     </v-flex>
   </v-layout>
   <v-flex
     xs12
     sm12
     md12
     lg10
     xl10
     class="billPayments--content-padding billPayments--overlayCardFlex"
    data-qa="paymentsreviewscreen-flex-u3b4vx">
     <v-layout row wrap class="billPayments--content-padding" data-qa="paymentsreviewscreen-layout-a2bxep">
       <v-flex
         v-if="!repeatPayment && !repeatBillPayment"
         sm12
         xs12
         md12
         lg12
         xl12
         class="hidden-lg-and-up pb-2"
        data-qa="paymentsreviewscreen-flex-p7m48">
         <v-btn
           @click="navigateToHistory()"
           color="white"
           class="text-none px-4 py-2"
           outlined
            data-qa="paymentsreviewscreen-btn-j5rxq">{{ $t("billPayments.billPaymentHistory") }}</v-btn
         >
       </v-flex>
       <v-flex
         v-if="repeatPayment || repeatBillPayment"
         sm12
         xs12
         md12
         lg12
         xl12
         class="hidden-lg-and-up pb-2"
        data-qa="paymentsreviewscreen-flex-stul6b">
         <v-btn
           v-if="isInitiateBillPaymentPermitted"
           @click="navigateToNewBillPayment()"
           color="white"
           class="text-none px-4 py-2"
           outlined
            data-qa="paymentsreviewscreen-btn-v5l2sl">{{ $t("billPayments.newBillPaymentLabel") }}</v-btn
         >
       </v-flex>
       <v-flex xs12 sm11 md10 lg10 xl10 class="pt-0" data-qa="paymentsreviewscreen-flex-mht5b7q">
         <v-card data-qa="paymentsreviewscreen-card-kugvcs">
           <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-6 pt-5 pb-0" data-qa="paymentsreviewscreen-col-asla4k">
                     <v-row no-gutters class="pl-3" v-if="repeatPayment" data-qa="paymentsreviewscreen-row-qs4r1m">
                       <img
                       :src="getBillerLogo(config?.chargeInfo?.companyId)"
                       @error="onImageLoadFailure($event,config?.chargeInfo?.companyId)"
                       :width="getBillerLogo(config?.chargeInfo?.companyId) && !imageNotExist.includes(config?.chargeInfo?.companyId) ? '35' : '0'"
                       :height="getBillerLogo(config?.chargeInfo?.companyId) && !imageNotExist.includes(config.chargeInfo?.companyId) ? '30' : '0'"
                      data-qa="paymentsreviewscreen-img-vuv2fb">
                       <font class="text-h6 font-weight-bold">
                         {{ $t("billPayments.paymentDetails") }}</font
                       >
                     </v-row>
                     <v-row no-gutters class="pl-3" v-if="updatedSummary" data-qa="paymentsreviewscreen-row-tmnwqg">
                       <img
                       :src="getBillerLogo(config?.chargeInfo?.companyId)"
                       @error="onImageLoadFailure($event,config?.chargeInfo?.companyId)"
                       :width="getBillerLogo(config?.chargeInfo?.companyId) && !imageNotExist.includes(config?.chargeInfo?.companyId) ? '35' : '0'"
                       :height="getBillerLogo(config?.chargeInfo?.companyId) && !imageNotExist.includes(config?.chargeInfo?.companyId) ? '30' : '0'"
                      data-qa="paymentsreviewscreen-img-xuoya">
                       <font class="text-h6 font-weight-bold">
                         {{ $t("billPayments.summary") }}</font
                       >
                     </v-row>
           </v-col>
               <v-card-text class="text--primary pt-0" data-qa="paymentsreviewscreen-card-text-fydrg">
                 <DisplayDetails
                   :config="{
                     title: '',
                     dataList: displayDataList,
                     translation: 'billPayments',
                   }"
                   class="pl-5"
                 />
               <v-row no-gutters data-qa="paymentsreviewscreen-row-qaekki">
                 <!--Repeat row with info-->
                 <v-col v-for="(item, i) in keys" :key="item.title" xs="12" sm="12" md="6" lg="6" xl="6" class="px-6 pt-2" :data-qa="`paymentsreviewscreen-col-68md4o-${i}`">
                   <div class="pa-1 overline font-weight-bold" :data-qa="`paymentsreviewscreen-div-68md4o-${i}`">
                     {{ item.title }}
                   </div>
                   <v-col xs="12" sm="12" md="6" lg="6" xl="6" class="px-6 pl-0 pr-0 pt-0" :data-qa="`paymentsreviewscreen-col-7klg7e-${i}`">
                   <div v-if="item.title === 'Mobile Number' && item.subtitle" class="pa-1" :data-qa="`paymentsreviewscreen-div-sqei8-${i}`">{{isdCode}} {{item.subtitle}}</div>
                   <div v-else class="pa-1" :data-qa="`paymentsreviewscreen-div-g6c4tr-${i}`">{{item.subtitle}}</div>
                   </v-col>
                 </v-col>
               </v-row>
             </v-card-text>
           <v-layout row data-qa="paymentsreviewscreen-layout-vrp42n">
             <v-flex v-if="repeatPayment" xs11 sm5 md5 lg3 xl5 class="py-2 px-1" data-qa="paymentsreviewscreen-flex-o3e0el">
               <v-btn
                 class="text-capitalize py-2 px-4"
                 :color="primaryColor"
                 elevation="2"
                 outlined
                 @click="goToHistory"
                 style="margin-left: 24px;"
                  data-qa="paymentsreviewscreen-btn-o8grr5">{{ $t("billPayments.back") }}</v-btn
               >
             </v-flex>
             <v-flex v-else xs11 sm5 md5 lg3 xl5 class="py-2 px-1" data-qa="paymentsreviewscreen-flex-lwbz5i">
               <v-btn
                 class="text-capitalize py-2 px-4"
                 :color="primaryColor"
                 elevation="2"
                 outlined
                 @click="handle()"
                 style="margin-left: 24px;"
                  data-qa="paymentsreviewscreen-btn-yd6vhq">{{ $t("billPayments.back") }}</v-btn
               >
             </v-flex>
             <v-flex v-if="repeatPayment" xs11 sm5 md5 lg3 xl5 class="py-2 px-1" data-qa="paymentsreviewscreen-flex-h7fvyb">
               <v-btn
                  v-if="isInitiateBillPaymentPermitted"
                 class="text-capitalize white--text py-2 px-4"
                 :color="primaryColor"
                 elevation="2"
                 :disabled="disableRepeatPayment"
                 @click="loadTemplate()"
                 style="margin-left: -62px;"
                  data-qa="paymentsreviewscreen-btn-5aaucl">{{ $t("billPayments.repeatPayment") }}</v-btn
               >
             </v-flex>
             <v-flex v-else xs11 sm5 md5 lg5 xl5 class="py-2 px-1" data-qa="paymentsreviewscreen-flex-c5990p">
               <v-btn
                  v-if="isInitiateBillPaymentPermitted"
                 class="text-capitalize white--text py-2 px-4"
                 :color="primaryColor"
                 elevation="2"
                 @click="setOtpComp()"
                 style="margin-left: -62px;"
                  data-qa="paymentsreviewscreen-btn-evo8q">{{ $t("billPayments.payNow") }}</v-btn
               >
             </v-flex>
           </v-layout>
         </v-card>
       </v-flex>
       <v-flex
             v-if="repeatPayment || repeatBillPayment"
             sm12
             xs12
             md2
             lg2
             xl2
             class="hidden-md-and-down pl-10"
            data-qa="paymentsreviewscreen-flex-osu2uw">
         <v-btn
           v-if="isInitiateBillPaymentPermitted"
           @click="navigateToNewBillPayment()"
           color="white"
           class="text-none px-4 py-2"
           outlined
            data-qa="paymentsreviewscreen-btn-wl2fl">{{ $t("billPayments.newBillPaymentLabel") }}</v-btn
         >
       </v-flex>
       <v-flex
             v-if="!repeatPayment && !repeatBillPayment"
             sm12
             xs12
             md2
             lg2
             xl2
             class="hidden-md-and-down pl-10"
            data-qa="paymentsreviewscreen-flex-cgffqs">
         <v-btn
           @click="navigateToHistory()"
           color="white"
           class="text-none px-4 py-2"
           outlined
            data-qa="paymentsreviewscreen-btn-7qz97j">{{ $t("billPayments.billPaymentHistory") }}</v-btn
         >
       </v-flex>
     </v-layout>
   </v-flex>
   <!-- For OTP -->
   <!-- OTP Section -->
   <Modal
     v-if="!enablePaymentPage && enableOTP && showOTPScreen"
     :config="modalConfig.otp"
     @cancel="onOtpModalClose"
   >
     <span slot="modalContent" data-qa="paymentsreviewscreen-span-uxt4tk">
       <OtpInput :otpConfig="otpSettings" />
     </span>
   </Modal>
   <!-- For OTP -->
    <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
   <!-- Payment Successful Model-->
   <Modal
     v-if="showConfirmationModal"
     :config='modalConfig.successBillsPayment'
     @btn1Action="newPayment()"
     @btn2Action="navigateToDashboard()"
     @btn3Action="downloadPaymentProofEnabled()"
    >
   </Modal>
   <Modal
     v-if="showErrorModal"
     :config='modalConfig.errorBillsPayment'
     @btn1Action="tryAgain()"
     @btn2Action="navigateToDashboard()">
   </Modal>
 </v-flex>
</template>
<script>
import '@/styles/pages/billPayments.scss'
import CommonService from '@/service/commonService.js'
import { uuid } from 'vue-uuid'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
// For OTP
import OtpInput from '@/components/common/OtpInput.vue'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'
import event from '@/util/event'
import store from '@/core/store'
// For OTP

export default {
  name: 'PaymentsReviewScreen',
  props: {
    configData: {
      type: Object,
      default: undefined
    },
    displayData: {
      type: Object,
      default: undefined
    },
    chargeResponse: {
      type: Object,
      default: undefined
    }
  },
  // FOR OTP
  components: {
    OtpInput,
    DisplayDetails,
    DownloadPaymentProof,
    Modal: () => import('@/components/common/Modal.vue')
  },
  // FOR OTP
  data () {
    return {
      display: {},
      config: {},
      // FOR OTP
      enablePaymentPage: true,
      paymentPayload: {},
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successBillsPayment: {
          enabled: true,
          title: this.$t('billPayments.paymentSuccessfulMessage'),
          body: this.$t('billPayments.subtitle'),
          persistent: true,
          btn1Label: this.$t('billPayments.goToHistory'),
          btn2Label: this.$t('billPayments.goToDashboard'),
          width: 600
        },
        errorBillsPayment: {
          enabled: true,
          title: this.$t('billPayments.paymentErrorfulMessage'),
          body: this.$t('billPayments.paymentErrorSubtitle'),
          persistent: true,
          btn1Label: this.$t('billPayments.tryAgain'),
          btn2Label: this.$t('billPayments.goToDashboard'),
          width: 600
        }
      },
      enableOTP: this.$appSettings.defaultConfigurations
        .enableOTPForBillPayment,
      showOTPScreen: false,
      payBill: false,
      showConfirmationModal: false,
      showErrorModal: false,
      paymentCheck: undefined,
      uuid: uuid.v1(),
      repeatPayment: false,
      repeatBillPayment: false,
      newBillPayment: false,
      updatedSummary: false,
      isdCode: '',
      keys: [],
      billerCurrency: '',
      disableRepeatPayment: false,
      imageNotExist: [],
      displayDataList: [],
      errorCodes: [
        '20020988',
        '20020989',
        '20100002',
        '20020987',
        '40009256',
        '40280151',
        '40112846',
        '20021006',
        '11400302',
        '20020040'
      ],
      isInitiateBillPaymentPermitted: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      showDownloadPayment: false,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
      // FOR OTP
    }
  },
  created () {
    this.display = this.displayData
    this.config = this.configData

    if (store.getters['profileStore/profileData'].customerDetails && store.getters['profileStore/profileData'].customerDetails.SMS) {
      this.isdCode = store.getters['profileStore/profileData'].customerDetails.SMS.isdCode
    }
    if (store.getters['userStore/userData'].billerCurrency) {
      this.billerCurrency = store.getters['userStore/userData'].billerCurrency
    }
    // Fetch Permissions for SME Users
    const permissions = store.getters['profileStore/profileData']?.permissions
    this.isInitiateBillPaymentPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('INITIATE_BILL_PAYMENTS') : true
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && !this.enablePaymentPage && this.enableOTP && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.payBill = true
        this.billPayment()
      } else {
        this.payBill = false
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
    event.$on('updateSummary', (arg, chargeInfo, causes) => {
      this.displayDataList = []
      // setTimeout(() => {
      this.disableRepeatPayment = causes
      this.display = arg
      this.config = chargeInfo
      this.keys = []
      if (this.display && this.display.additionalKeyDescription && this.display.additionalKeyDescription.length) {
        this.display.additionalKeyDescription.forEach((element, index) => {
          this.keys.push({ title: element, subtitle: this.display.additionalValues[index] })
        })
      }
      this.repeatPayment = true
      this.updatedSummary = false
      // Custom Data Fix
      if (this.display && this.display.additionalKeyDescription.length && this.display.additionalValues.length && this.display.customDataMap) {
        this.keys = this.display.customDataMap
      }
      if (store.getters['userStore/userData'].billerCurrency) {
        this.billerCurrency = store.getters['userStore/userData'].billerCurrency
      }
      this.setDisplayData()
      // }, 200)
    })
    event.$on('repeatHeaders', (args) => {
      this.display = args
      if (this.display && this.display.repeatBillPayment) {
        this.repeatPayment = false
        this.repeatBillPayment = true
        this.updatedSummary = true
      }
    })
    event.$on('repeatHistoryConfig', (args) => {
      this.config = args
      if (store.getters['userStore/userData'].repeatHistoryDisplay) {
        this.display = store.getters['userStore/userData'].repeatHistoryDisplay
        if (store.getters['userStore/userData'].customDataMap) {
          this.keys = store.getters['userStore/userData'].customDataMap
        }
      }
      /* if (this.display.customDataMap) {
       this.keys = store.getters['userStore/userData'].repeatHistoryDisplay.customDataMap
     } */
      this.repeatPayment = true
      this.updatedSummary = false
      this.navigateToReviewHistory()
    })
    event.$on('repeatSummary', (ele, chargeInfo) => {
      this.displayDataList = []
      // setTimeout(() => {
      this.display = ele
      this.config = chargeInfo
      this.keys = []
      if (this.display && this.display.additionalKeyDescription && this.display.additionalValues.length) {
        this.display.additionalKeyDescription.forEach((element, index) => {
          this.keys.push({ title: element, subtitle: this.display.additionalValues[index] })
        })
      }
      // Custom Data Fix
      if (this.display && this.display.additionalKeyDescription.length && this.display.additionalValues.length && this.display.customDataMap) {
        this.keys = this.display.customDataMap
      }
      if (store.getters['userStore/userData'].billerCurrency) {
        this.billerCurrency = store.getters['userStore/userData'].billerCurrency
      }
      this.setDisplayData()
      // }, 200)
    })
    if (this.display && this.display.repeatPayment) {
      this.repeatPayment = true
    }
    if (this.display && this.display.updatedSummary) {
      this.updatedSummary = true
    }
    if (this.display && this.display.repeatBillPayment) {
      this.repeatBillPayment = true
    }
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successBillsPayment.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  mounted () {
    // setTimeout(() => {
    if (this.display && this.display.additionalKeyDescription) {
      this.keys = []
      /* this.display.additionalKeyDescription.forEach((element, index) => {
        this.keys.push({ title: element, subtitle: this.display.additionalValues[index] })
       }) */
      // Custom Data Fix
      if (this.display && this.display.customDataMap && this.display.additionalKeyDescription && this.display.additionalKeyDescription.length) {
        this.keys = this.display.customDataMap
      }
      if (this.config) {
        store.dispatch('userStore/setUserData', {
          repeatHistoryConfig: this.config
        })
      }
      store.dispatch('userStore/setUserData', {
        repeatHistoryDisplay: this.display
      })
      if (this.repeatPayment) {
        const dynamicFields = store.getters['userStore/userData'].repeatHistoryDisplay.customDataMap
        store.dispatch('userStore/setUserData', {
          customDataMap: dynamicFields
        })
      }
    }
    if (this.display) { this.disableRepeatPayment = this.display.causes }
    // }, 500)
    this.setDisplayData()
  },
  methods: {
    navigateToReviewHistory () {
      event.$emit('navigateToReviewHistory', true)
    },
    setDisplayData () {
      this.displayDataList.push(
        {
          label: 'billerLabel',
          value: this.config.chargeInfo.companyId
        },
        {
          label: 'fromAccountLabel',
          value: this.config.chargeInfo.fromAccountType
        },
        {
          label: 'consumerIDLabel',
          value: this.config.chargeInfo.customerId
        },
        {
          label: 'billReferenceIDLabel',
          value: this.config.chargeInfo.reference
        },
        {
          label: this.repeatPayment ? 'paymentDate' : 'billDueDateLabel',
          value: this.config.chargeInfo.dueDate
        },
        {
          label: 'totalPaymentAmountLabel',
          value: this.$formatter.currency.format(this.display.totalAmount, this.billerCurrency)
        },
        {
          label: 'billAmountLabel',
          value: this.$formatter.currency.format(this.config.chargeInfo.billAmount, this.billerCurrency)
        },
        {
          label: 'chargeLabel',
          value: this.$formatter.currency.format(this.display.charge, this.billerCurrency)
        }
      )
      this.downloadDataDetails = []
      this.downloadDataDetails.push(
        {
          label: 'biller',
          value: this.config?.chargeInfo?.companyId
        },
        {
          label: 'fromAcc',
          value: this.$formatter.maskNumber(this.config?.chargeInfo?.debitAccountNumber)
        },
        {
          label: 'consumerId',
          value: this.config?.chargeInfo?.customerId
        },
        {
          label: 'billRefId',
          value: this.config?.chargeInfo?.reference
        },
        {
          label: 'totalPaymentAmount',
          value: this.$formatter.currency.format(this.display?.totalAmount, this.billerCurrency)
        },
        {
          label: 'paymentDate',
          value: this.config?.chargeInfo?.dueDate
        },
        {
          label: 'charges',
          value: this.$formatter.currency.format(this.display?.charge, this.billerCurrency)
        }
      )
    },
    // ForOTP
    onOtpModalClose () {
      this.enablePaymentPage = false
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    navigateToHistory () {
      this.$router.push({ path: '/billPayment' })
    },
    navigateToNewBillPayment () {
      this.$router.push({ path: '/newBillPayment' })
    },
    getBillerLogo (name) {
      try {
        return `/assets/Billers/${name}.svg`
        // return require(`/assets/Billers/${name}.svg`)
      } catch (e) {
        return undefined
      }
    },
    onImageLoadFailure (event, name) {
      this.imageNotExist.push(name)
      event.target.src = '/assets/Billers/Empty.jpg'
    },
    async setOtpComp () {
      if (this.enableOTP) {
        // create acc WITH otp Authentication
        this.enablePaymentPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
        this.modalConfig.otp.enableSave = true
      } else {
        // call Bill Payment WITHOUT otp Authentication
        await this.billPayment()
      }
    },
    async billPayment () {
      this.onOtpModalClose()
      await this.payBills()
    },
    loadTemplate () {
      this.config.additionalKeyDescription = this.display.additionalKeyDescription
      this.config.additionalValues = this.display.additionalValues
      this.config.additionalProps = this.display.additionalProps
      event.$emit('repeatTemplate', this.config)
    },
    async payBills () {
      this.paymentPayload = {
        sourcePaymentReference: this.uuid,
        debitAccountNumber: this.config.chargeInfo.debitAccountNumber,
        // paymentAmount: this.display.totalAmount,
        paymentDate: this.display.paymentDate,
        billPaymentDetails: this.chargeResponse,
        sourceId: 'DIGITAL-CHANNEL'
      }
      if (this.display.totalAmount) {
        this.paymentPayload.paymentAmount = this.display.totalAmount
      } else {
        this.paymentPayload.paymentAmount = this.paymentPayload.billPaymentDetails.paymentAmount
      }
      this.paymentPayload.billPaymentDetails.id = this.display.id
      this.paymentPayload.billPaymentDetails.customerIdWithBiller = this.display.customerId
      this.paymentPayload.billPaymentDetails.reference = this.display.reference
      this.paymentPayload.billPaymentDetails.additionalData = this.display.otherFields
      this.paymentCheck = await CommonService.confirmBillPayment(this.paymentPayload)
      if (this.paymentCheck && this.paymentCheck.paymentStatus === 'SUCCESSFUL') {
        event.$emit('paymentCompleted', true)
        this.showConfirmationModal = true
      } else if (this.paymentCheck && this.paymentCheck.causes && this.paymentCheck.causes[0] && this.paymentCheck.causes[0].code && (this.errorCodes.includes(this.paymentCheck.causes[0].code))) {
        this.showErrorModal = true
        this.modalConfig.errorBillsPayment.enabled = true
      }
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      const titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.paymentCheck?.hostTransactionRef },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.completed') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.billPayment_title),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.paymentCheck?.hostTransactionRef
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
      // this.showDownloadPayment = true
    },
    newPayment () {
      if (this.repeatBillPayment) {
        event.$emit('goToHistory', true)
        this.showConfirmationModal = false
      } else {
        this.showConfirmationModal = false
        this.$router.push({ path: '/billPayment' })
      }
    },
    goToHistory () {
      event.$emit('goToHistory')
    },
    navigateToDashboard () {
      this.$router.push({ path: '/home' })
    },
    // FOrOTP
    handle () {
      this.$emit('handle', true)
    },
    tryAgain () {
      this.showErrorModal = false
      this.modalConfig.errorBillsPayment.enabled = false
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    display: {
      handler (val) {
        /* eslint-disable-next-line */
       if (val && val.customDataMap && val.additionalValues.length) {
          this.keys = []
          this.keys = val.customDataMap.reduce((unique, o) => {
            if (!unique.some(obj => obj.title === o.title)) {
              unique.push(o)
            }
            return unique
          }, [])
        }
        if (val && ((!val.additionalProps) || (val.additionalProps && !val.additionalProps.length))) {
          this.keys = []
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
    event.$off('download_payment_proof')
  }
}
</script>
